import {handleActions} from 'redux-actions';
import actions from './chat.actions';
import chatMatches from './chatMatches';

// Invert result of curried function
const inverter = f => val => !f(val);

/**
 * Merge two lists of chats, with those in the second list taking precedent.
 * @param a
 * @param b
 * @returns {*[]} Updated list
 */
const merge = (a, b) => [
	...a.filter(existing => {
		const matcher = chatMatches(existing);
		return !b.find(matcher); // Filter out those we received again, so we get latest
	}),
	...b
];

const reducer = handleActions(
	{
		[actions.chatRetrieving]: state => ({
			...state,
			items: [],
			retrieving: true
		}),
		[actions.chatRetrieved]: (state, {payload: {items, more, nextOffset}}) => ({
			...state,
			items: merge(state.items, items),
			more,
			nextOffset,
			retrieving: false
		}),
		[actions.chatMoreRetrieved]: (state, {payload: {items, more, nextOffset}}) => ({
			...state,
			items: merge(state.items, items),
			more,
			nextOffset
		}),
		[actions.chatOpen]: (state, {payload}) => ({
			...state,
			items: [
				{...payload}, // Hoist to the top
				...state.items.filter(inverter(chatMatches(payload))) // Filter it out of existing state
			]
		}),
		[actions.chatMessagesAdded]: (state, {payload: {code, messages}}) => ({
			...state,
			items: state.items.map(item => ({
				...item,
				lastMessage: item.code === code ? new Date() : item.lastMessage,
				messages: item.code === code ? item.messages.concat(messages) : item.messages
			}))
		}),
		[actions.chatSetState]: (state, {payload: {code, openState}}) => ({
			...state,
			items: state.items.map(item => ({
				...item,
				state: item.code === code ? openState : item.state
			}))
		}),
		[actions.chatDismiss]: (state, {payload: {code}}) => ({
			...state,
			items: state.items.filter(item => item.code !== code)
		})
	},
	{items: [], retrieving: false, more: undefined, nextOffset: undefined}
);

export default reducer;



// WEBPACK FOOTER //
// ./src/user/chat.reducer.js